export default __webpack_public_path__ + "static/media/include_5@2x.f05d1e9c.jpg";